import React from "react";

/**
 * Icon "download into tray" (modern stroke).
 * Uses `currentColor` so it inherits button text color.
 */
export default function DownloadTrayIcon({ size = 20, className = "" }) {
  const s = Number(size) || 20;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* arrow */}
        <path d="M12 3v9" />
        <path d="M8.5 10.5 12 13.9l3.5-3.4" />
        {/* tray */}
        <path d="M4 15.5v3A2.5 2.5 0 0 0 6.5 21h11A2.5 2.5 0 0 0 20 18.5v-3" />
        <path d="M4 15.5c0-1.1.9-2 2-2h2" />
        <path d="M20 15.5c0-1.1-.9-2-2-2h-2" />
      </g>
    </svg>
  );
}

